import vzanAddressNew from './index.vue'
export default {
  install(Vue) {
    Vue.component('vzan-address-new', vzanAddressNew)
  }
}
